module.exports = __webpack_public_path__ + "img/no_data.60f97f6d.png";